var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.medias === null
        ? _c("Spinner")
        : _c("ImageViewer", {
            attrs: { medias: _vm.medias, isShowDelete: _vm.editable },
            on: { "removed-media": _vm.onMediaRemoved }
          }),
      _vm._v(" "),
      _vm.editable
        ? _c("DropZone", {
            attrs: { formId: "dz" + _vm.uid },
            on: { uploaded: _vm.onFileUploaded }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }